@if(intructions()){
    <section class="indication-card-container" [class.hide-mobile]="isButtomSheetOpen()">
        <div class="indication-card-wrapper" (click)="handleIndicationCardClick()" [class.success]="stepProgress() === 100">
            <indication
                [intructions]="intructions()" 
                [timeRemaining]="timeRemaining()"
                [isSuccess]="stepProgress() === 100"
                [progress]="stepProgress()"
                [sign]="sign()"
                [nextItem]="nextItem()"
            ></indication>
            @if(showToggleGPSButton()){
                <ci-button (click)="toggleGPS($event)" class-name="ci-btn-primary-s-filled" type="button" icon-name="nacional-ciudades" aria-label="Home Button Filled Small">
                    {{ 'Localízame' | translate }}
                </ci-button>
            }
        </div>
    </section>
}
